import { Button, Modal, Popconfirm, Space } from "antd";
import type { FC } from "react";
import type { DeploymentTarget } from "../../../types";
import type { AcfRow } from "../types";

interface TargetsModalProps {
  object: AcfRow | null;
  targets: DeploymentTarget[];
  onClose: () => void;
  onRemoveTarget: (environmentId: string, removeFromSite: boolean) => void;
}

export const TargetsModal: FC<TargetsModalProps> = ({ object, targets, onClose, onRemoveTarget }) => {
  return (
    <Modal title={`Deployment targets${object ? ` — ${object.title || object.key}` : ""}`} open={Boolean(object)} onCancel={onClose} footer={null}>
      {object && (
        <Space direction="vertical" style={{ width: "100%" }}>
          {targets.map((target) => (
            <Space key={target.id} style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <span>
                {target.projectName} / {target.environmentName}
              </span>
              <Space size="small">
                <Popconfirm
                  title="Remove tracking only"
                  description="The ACF object stays live on this site, Loopress just stops tracking it. A future republish to this target will create a duplicate."
                  onConfirm={() => onRemoveTarget(target.environmentId, false)}
                  okText="Remove tracking"
                  cancelText="Cancel"
                >
                  <Button size="small">Remove tracking only</Button>
                </Popconfirm>
                <Popconfirm
                  title="Remove from site"
                  description={`This will delete the ACF object from ${target.projectName} / ${target.environmentName} right now. This cannot be undone.`}
                  onConfirm={() => onRemoveTarget(target.environmentId, true)}
                  okText="Remove from site"
                  okButtonProps={{ danger: true }}
                  cancelText="Cancel"
                >
                  <Button size="small" danger>
                    Remove from site
                  </Button>
                </Popconfirm>
              </Space>
            </Space>
          ))}
        </Space>
      )}
    </Modal>
  );
};
